export default {
  translation: {
    common: {
      accept: 'Přijmout',
      alreadyUser: 'Již máte účet?',
      and: 'a',
      backToLogin: 'Zpět na přihlašovací stránku',
      continueWith: 'Pokračovat s {{provider}}',
      coreNotFound: 'Nepodařilo se načíst základní nastavení',
      createAccount: 'Vytvořit účet',
      createYourAccount: 'Vytvořte si účet',
      emailOrUsername: 'E-mail nebo uživatelské jméno',
      invalidUsernameOrPassword: 'Neplatné uživatelské jméno nebo heslo',
      localRegistrationDisabled: 'Lokální registrace uživatelů je zakázána administrátorem',
      login: 'Přihlásit se',
      logInToBoards: 'Přihlásit se',
      newToBoards: 'Nový v 4ga Boards?',
      noInternetConnection: 'Žádné připojení k internetu',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      policyNotAccepted: 'Přijměte prosím Podmínky služby a Zásady ochrany osobních údajů',
      privacyPolicy: 'Zásady ochrany osobních údajů',
      register: 'Registrovat',
      registerWithGoogle: 'Registrovat přes Google',
      registrationDisabled: 'Registrace uživatelů je zakázána administrátorem',
      serverConnectionFailed: 'Připojení k serveru selhalo',
      ssoRegistrationDisabled: 'SSO registrace je zakázána administrátorem',
      termsOfService: 'Podmínky služby',
      togglePasswordVisibility: 'Zobrazit/skrýt heslo',
      unknownError: 'Neznámá chyba, zkuste to později',
    },

    action: {
      logIn: 'Přihlásit se',
    },
  },
};
